var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-md-12" }, [
      _c(
        "div",
        { staticClass: "logs" },
        [
          _vm.logs.length
            ? _vm._l(_vm.logs, function(log, index) {
                return _c("div", { key: index, staticClass: "wrapper-log" }, [
                  _c("div", { staticClass: "topic" }, [
                    _c("strong", [
                      _vm._v(
                        "\n              " +
                          _vm._s(log._topic) +
                          "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "actions" }, [
                      _vm.hasRoleEdit
                        ? _c(
                            "button",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.handleToggleStatus(index, log)
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fas fa-check",
                                class: [
                                  { "text-success": log.status === "done" }
                                ],
                                staticStyle: { "font-size": "17px" }
                              })
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      log.status === "todo" && _vm.hasRoleEdit
                        ? _c(
                            "button",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.handleEdit(index, log)
                                }
                              }
                            },
                            [_c("i", { staticClass: "fas fa-pen" })]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      log.status === "todo" && _vm.hasRoleDelete
                        ? _c(
                            "button",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.handleDelete(index, log)
                                }
                              }
                            },
                            [_c("i", { staticClass: "fas fa-trash" })]
                          )
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  log.description
                    ? _c("div", { staticClass: "description" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(log.description) +
                            "\n          "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  log.schedule_date
                    ? _c("div", { staticClass: "schedule-date" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("message.scheduledate")) +
                            ": " +
                            _vm._s(_vm.getDateTime(log.schedule_date)) +
                            "\n            |\n            " +
                            _vm._s(_vm.getFriendlyTime(log.schedule_date)) +
                            "\n          "
                        )
                      ])
                    : _vm._e()
                ])
              })
            : [_c("div", [_vm._v("-")])]
        ],
        2
      )
    ]),
    _vm._v(" "),
    _vm.showCreateButton && _vm.hasRoleCreate
      ? _c("div", { staticClass: "col-md-12 mt-2" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-light btn-create",
              on: { click: _vm.handleCreate }
            },
            [_vm._v("\n      + " + _vm._s(_vm.createButtonText) + "\n    ")]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1621685a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1621685a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseSectionDocRefLog.vue
// module id = null
// module chunks = 